import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import auth from './modules/auth'
import errors from './modules/errors'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,

  modules: {
    auth,
    errors
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js